import React, { useEffect } from "react";
import SideBar from "../components/bars/SideBar";
import Footer from "../components/bars/Footer";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import styles from "./css/Layout.module.css";
import { RootState } from "@/store/store";
import { useTranslation } from "react-i18next";

const Layout: React.FC = () => {
  const { i18n } = useTranslation("LanguageSwitcher");
  const location = useLocation();
  const decodedPathname = decodeURIComponent(location.pathname);
  const { entityName } = useParams<{ entityName: string }>();
  const { userAuth } = useSelector((state: RootState) => state.user);

  const allowFullScreen =
    decodedPathname === `/${entityName}/cities` ||
    decodedPathname.includes(`/${entityName}/projects/create`) ||
    (decodedPathname.includes(`/${entityName}/project`) && decodedPathname.includes(`/update`)) ||
    decodedPathname.includes(`/alternative/`);

  const loginPage =
    decodedPathname === `/${entityName}` ||
    decodedPathname === `/${entityName}/`;

  const shouldShowSideBar =
    decodedPathname !== `/${entityName}/` &&
    decodedPathname !== `/${entityName}`;

  useEffect(() => {
    const savedLang = localStorage.getItem("i18nextLng") || "he";
    i18n.changeLanguage(savedLang);
    localStorage.setItem("i18nextLng", savedLang);
    document.documentElement.dir = savedLang === "he" ? "rtl" : "ltr";
  }, []);

  const footerHeight = 40; // adjust to your actual footer height in px

  return (
    <div className="flex flex-col min-h-screen w-screen overflow-hidden">
      
      {/* Main Section: Sidebar + Content */}
      <div className="flex w-full" style={{ height: `calc(100vh - ${loginPage ? 0 : footerHeight}px)` }}>
        
        {/* Sidebar */}
        {shouldShowSideBar && userAuth && (
          <div className="w-[14rem] h-full">
            <SideBar />
          </div>
        )}

        {/* Main Content */}
        <div className={`flex-grow overflow-y-auto ${!allowFullScreen? "h-[calc(100%-1.6rem)] bg-white rounded-lg mr-[0.8rem] ml-[0.8rem] mt-[0.8rem] mb-[0.8rem]" : "h-full"}`}>
          <Outlet />
        </div>

      </div>

      {/* Footer under both columns */}
      {!loginPage && (
        <div
          className="w-full flex items-center justify-center"
          style={{ height: `${footerHeight}px` }}
        >
          <Footer />
        </div>
      )}

    </div>
  );
};

export default Layout;
